import { createContext, ReactNode, useMemo } from "react";

import { ApplicationType, getApplicationType } from "@ryde/shared";

export interface IGlobalAppContextValue {
  webApplicationType: ApplicationType;
}

export interface IGlobalAppContext {
  applicationType: ApplicationType;
}

export const GlobalAppContext = createContext<IGlobalAppContext>({
  applicationType: ApplicationType.Unset,
});

export const GlobalAppContextProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactNode => {
  const context = useMemo(
    () => ({
      applicationType: getApplicationType(),
    }),
    [],
  );

  return (
    <GlobalAppContext.Provider value={context}>
      {children}
    </GlobalAppContext.Provider>
  );
};
